import type { CandidateProfileSkeletonProps } from "../personalization.types";
import { Skeleton } from "@artha/ui";
import { CreatorFloatingActions } from "@/components/layout/CreatorFloatingActions";
import {
  PROFILE_CARD_CHIP_KINDS,
  PROFILE_CARD_CLASS_NAME,
  PROFILE_CARD_HISTORY_KINDS,
} from "./profile-cards/profileCards.constants";

function ProfileSkeletonHeader() {
  return (
    <div className="mb-4 flex h-8 items-center justify-between gap-3">
      <Skeleton className="h-5 w-24" />
      <Skeleton className="h-4 w-4" />
    </div>
  );
}

export function CandidateProfileSkeleton({ readOnly = false }: CandidateProfileSkeletonProps) {
  return (
    <div role="status" aria-label="Loading profile" aria-busy="true">
      <div
        aria-hidden="true"
        className="space-y-5 motion-reduce:[&_.animate-pulse]:animate-none"
      >
        <div className={PROFILE_CARD_CLASS_NAME}>
          <ProfileSkeletonHeader />
          <div className="space-y-3">
            <Skeleton className="h-7 w-2/3" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
            <div className="space-y-2 border-t border-[#EAECF0] pt-3">
              <Skeleton className="h-3 w-2/3" />
              <Skeleton className="h-3 w-1/2" />
            </div>
            <div className="flex flex-wrap gap-2">
              <Skeleton className="h-7 w-36" />
              <Skeleton className="h-7 w-16" />
            </div>
          </div>
        </div>
        {PROFILE_CARD_HISTORY_KINDS.map((kind) => (
          <div key={kind} className={PROFILE_CARD_CLASS_NAME}>
            <ProfileSkeletonHeader />
            <div className="flex gap-3">
              <Skeleton className="h-9 w-9 shrink-0" />
              <div className="min-w-0 flex-1 space-y-2">
                <Skeleton className="h-4 w-5/6" />
                <Skeleton className="h-3 w-2/3" />
                <Skeleton className="h-3 w-1/2" />
                <div className="space-y-2 pt-2">
                  <Skeleton className="h-3 w-full" />
                  <Skeleton className="h-3 w-full" />
                  <Skeleton className="h-3 w-3/4" />
                </div>
              </div>
            </div>
          </div>
        ))}
        {PROFILE_CARD_CHIP_KINDS.map((kind) => (
          <div key={kind} className={PROFILE_CARD_CLASS_NAME}>
            <ProfileSkeletonHeader />
            <div className="flex flex-wrap gap-2">
              <Skeleton className="h-7 w-16" />
              <Skeleton className="h-7 w-24" />
              <Skeleton className="h-7 w-20" />
              <Skeleton className="h-7 w-28" />
            </div>
          </div>
        ))}
        {!readOnly ? <CreatorFloatingActions>
          <Skeleton className="h-10 w-10 shrink-0 rounded-lg" />
          <Skeleton className="h-10 flex-1 rounded-lg" />
        </CreatorFloatingActions> : null}
      </div>
    </div>
  );
}
